import groq from 'groq';

export const localizedMotionQuery = (locale: string) => groq`
  *[_type == "motion" && isActive == true][0] {
    _id,
    title,
    description,
    backgroundImage {
      asset-> {
        _id,
        url,
        metadata {
          dimensions
        }
      },
      alt
    },
    isActive
  }
`;

export const motionQuery = groq`
  *[_type == "motion" && isActive == true][0] {
    _id,
    title,
    description,
    backgroundImage {
      asset-> {
        _id,
        url,
        metadata {
          dimensions
        }
      },
      alt
    },
    isActive
  }
`;
